// Minimal IndexedDB wrapper for the offline layer. Three stores:
// readCache (GET responses), writeQueue (pending mutations, FIFO), deadLetter.
const DB_NAME = 'tododuk-offline';
const VERSION = 1;

let dbPromise = null;

function openDb() {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, VERSION);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains('readCache')) db.createObjectStore('readCache');
        if (!db.objectStoreNames.contains('writeQueue')) db.createObjectStore('writeQueue', { keyPath: 'seq', autoIncrement: true });
        if (!db.objectStoreNames.contains('deadLetter')) db.createObjectStore('deadLetter', { keyPath: 'seq', autoIncrement: true });
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  return dbPromise;
}

function txStore(name, mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(name, mode);
    const req = fn(tx.objectStore(name));
    tx.oncomplete = () => resolve(req.result);
    tx.onerror = () => reject(tx.error);
  }));
}

export function cacheGet(key) {
  return txStore('readCache', 'readonly', (s) => s.get(key));
}

export function cachePut(key, value) {
  return txStore('readCache', 'readwrite', (s) => s.put({ data: value, ts: Date.now() }, key));
}

export function cacheKeys() {
  return txStore('readCache', 'readonly', (s) => s.getAllKeys());
}

export function cacheDelete(key) {
  return txStore('readCache', 'readwrite', (s) => s.delete(key));
}

export function queueAdd(op) {
  return txStore('writeQueue', 'readwrite', (s) => s.add({ ...op, createdAt: Date.now() }));
}

export function queueAll() {
  return txStore('writeQueue', 'readonly', (s) => s.getAll());
}

export function queueRemove(seq) {
  return txStore('writeQueue', 'readwrite', (s) => s.delete(seq));
}

export function queueCount() {
  return txStore('writeQueue', 'readonly', (s) => s.count());
}

export function deadLetterAdd(op) {
  return txStore('deadLetter', 'readwrite', (s) => s.add(op));
}
